var swiper = new Swiper('.swiper-container.swiper-sol', {
    navigation: {
      nextEl: '.swiper-button-next.swiper-sol',
      prevEl: '.swiper-button-prev.swiper-sol',
    },
    centeredSlides: true,
    centeredSlidesBounds: true,
    slidesPerView: 1.25,
    slidesPerGroup: 1,
    spaceBetween: 20,
    breakpoints: {
      768: {
        slidesPerView: 2.33,
        slidesPerGroup: 2,
        spaceBetween: 30,
      },
      1408: {
        slidesPerView: 3.5,
        slidesPerGroup: 3,
        spaceBetween: 60,
      },
    },
    pagination: {
      el: '.swiper-pagination.swiper-sol',
      type: 'bullets',
      clickable: true
    },
});



